#import "./SentenceDetails.graphql"
query AliyahSentencesQuery($aliyah: ID!) {
  aliyahSentences(aliyah: $aliyah) {
    ...sentenceDetails
  }
}
